import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
import { OpenAPI } from "@pro-sto/api-client";
import { StoreProvider } from "@/stores/StoreContext";
import { authStore } from "@/stores/AuthStore";
import { setupApiInterceptors } from "@/helpers/setupApiInterceptors";
import App from "./App";

// Design tokens
import "@pro-sto/ui/styles/variables.css";
// Minimal base (no aggressive resets that break HeroUI)
import "./styles/base.css";

// Tailwind v4 + HeroUI styles (must be a CSS import so Tailwind plugin processes @apply)
import "./styles/tailwind.css";
// HeroUI overrides — match pro-sto design tokens
import "./styles/heroui-theme.css";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0,
  });
}

// Configure API client — empty string means relative URL (same origin, nginx proxies /api)
OpenAPI.BASE = import.meta.env.VITE_API_BASE_URL ?? "";

// Настройка interceptors для автоматического обновления токенов
setupApiInterceptors(authStore);

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element not found");
}

createRoot(root, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <StoreProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StoreProvider>
  </StrictMode>,
);
